export const MIN_DATE_PICKER_VALUE = '01/01/1900';

export class DateUtils {
  public static readonly MIN_DATE_PICKER_VALUE = MIN_DATE_PICKER_VALUE;

  /**
   * @param value Parsable date
   * @returns m/d/yyyy
   */
  public static formatDateMDYYYY(value?: string | null): string {
    if (!value) return '';
    try {
      let date = new Date(value);
      const offset = date.getTimezoneOffset() * 60000; //offset in milliseconds
      date = new Date(date.valueOf() + offset);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    } catch (err) {
      console.error(err);
      return value;
    }
  }

  /**
   * @param value Parsable date (ISO `yyyy-mm-dd` or `m/d/yyyy`)
   * @returns MM/DD/YYYY (zero-padded), or empty string if falsy/unparsable
   */
  public static formatDateMMDDYYYY(value?: string | null): string {
    if (!value) return '';
    try {
      let date = new Date(value);
      if (isNaN(date.getTime())) return '';
      const offset = date.getTimezoneOffset() * 60000; //offset in milliseconds
      date = new Date(date.valueOf() + offset);
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${mm}/${dd}/${date.getFullYear()}`;
    } catch (err) {
      console.error(err);
      return '';
    }
  }

  public static formatISO8601(value: string): string {
    const date = new Date(value);
    return `${date.toLocaleDateString('en-us')} ${date.toLocaleTimeString('en-US')}`;
  }

  public static formatDateISO(date: Date): string {
    return date.toISOString().split("T")[0];
  };

  public static currentDateAddDays(days: number): Date {
    const date = new Date();
    date.setUTCDate(date.getUTCDate() + days);
    return date;
  }
}